import { Injectable } from '@angular/core';
import { NotificationModel } from 'src/app/models/notificationModel';

@Injectable({
    providedIn: 'root'
  })
  export class NotificationsStore {

    notifications: NotificationModel[];
    dropdownNotifications: NotificationModel[];
    totalRecords: number;
    totalUnreadNotifications: number;

    constructor() {
    }

    loadRecords(notifications: any[]) {
        this.notifications = notifications;
    }

    loadDropdownRecords(notifications: any[]) {
        this.dropdownNotifications = notifications;
    }
}